<div class="modal-overlay">
  <div #modalContent class="modal-content">
    <ng-content></ng-content>

    <button *ngIf="showButton" class="close" (click)="closeModal()">
      Fechar
    </button>
  </div>
</div>
